import React from 'react';
import InstructionsDialog from '../../../InstructionsDialog';
import Cookies from 'js-cookie';
import { DOMAIN } from '../../shared/utils';
import { PuzzleNames } from '../../../../utils/types';
import { TriwordStore } from '../TriwordStore';

const closeInstructions = () => {
  TriwordStore.update(s => {
    s.instructionsAreOpen = false;
    s.isSoftPaused = false;
  });

  Cookies.set(`${PuzzleNames.Triword}InstructionsDismissed`, 'true', {
    domain: DOMAIN,
    expires: 365,
  });
};

const Instructions = () => {
  const isOpen = TriwordStore.useState(s => s.instructionsAreOpen);

  return (
    <InstructionsDialog isOpen={isOpen} onClose={closeInstructions}>
      <h1 className="instructionsTitle">How to Play Triword</h1>
      <div className="instructionsBody triwordInstructions">
        <p>
          Given 3 clue fragments, find a fourth fragment that completes all 3 clues to form full words.
        </p>
        <h2>
          Example:
        </h2>
        <p>
          TUN / GON / IN + DRA <br/>
          = TUN<em>DRA</em> / <em>DRA</em>GON / <em>DRA</em>IN
        </p>
        <hr/>
        <p>
          • Any of the 3 clue fragments may be starting or ending fragments. Their order is random.
        </p>
        <p>
          • If you feel stuck, use any of the 3 lifelines available in the top right corner.
        </p>
      </div>
    </InstructionsDialog>
  );
};

export default Instructions;